import { render, staticRenderFns } from "./calcs.vue?vue&type=template&id=da98a7c6"
import script from "./calcs.vue?vue&type=script&lang=js"
export * from "./calcs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports